import { useEffect } from "react";
import buttonStyles from "../../../styles/UI/buttons.module.css";

const IconButtonComponent = ({
  icon,
  id,
  onClick,
  classes,
  disable,
  width,
  height,
  ariaLabel,
}: {
  id: string;
  icon: React.ReactNode;
  onClick: () => void;
  classes?: string;
  disable?: boolean;
  width?: number;
  height?: number;
  ariaLabel: string;
}) => {
  // useEffect to programaticcaly set the color of icon.
  useEffect(() => {
    const buttonElement = document.getElementById(id);
    const path = buttonElement?.querySelectorAll("path");
    if (path && path[0]) {
      path[0].setAttribute(
        "fill",
        disable
          ? "var(--col-graph-first-1)"
          : "var(--col-interaction-secondary)",
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disable]);

  return (
    <button
      aria-label={ariaLabel}
      id={id}
      className={`${classes || null} ${buttonStyles.iconButton}`}
      onClick={onClick}
      disabled={disable}
      style={{
        width: width ? `${width}px` : "40px",
        height: height ? `${height}px` : "40px",
      }}
    >
      {icon}
    </button>
  );
};

export default IconButtonComponent;
